/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { requisitionsRequisitionLineRowStyles } from "@monsma/Overrides/Widgets/Requisitions/RequisitionsRequisitionLineRow";
import { removeLinkStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

requisitionsRequisitionLineRowStyles.qtyOrderedTextField = {
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.formInputWrapper")}
            width: 62px;
            margin-right: 20px;
        `,
        inputSelect: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")}
            background: ${getColor("common.ui8")};
            font-size: 14px;
        `,
        formField: css`
            width: auto;
        `,
    },
};

requisitionsRequisitionLineRowStyles.xRequisitionsRequisitionLineRowStyles = {
    removeLink: removeLinkStyle,
};
